module.exports = __webpack_public_path__ + "static/media/showroom-mobile.2cfd0db7.png";